import type { VoidFunctionComponent } from 'react';
import Badge from './Badge';
import * as Loading from './Loading';
import styles from './FileViewer.module.less';

type Props = {
  isLoading: boolean;
  isDeclared: boolean;
};

/**
 * FileViewerOrigin displays information related to the "origin" of the
 * license, ie: was it discovered by FOSSA or declared by the package author?
 * Because we determine the "origin" from the file matches request (by checking
 * if one of the results is the special `DECLARED_LICENSE` path), we pass down
 * the AsyncStatus of that request so that we know if we need to display the
 * loading UI instead of the badge + text.
 */
const FileViewerOrigin: VoidFunctionComponent<Props> = ({ isLoading, isDeclared }) => (
  <div className={styles.origin}>
    {isLoading ? (
      <Loading.Origin />
    ) : (
      <>
        <Badge isDeclared={isDeclared} />
        <span>
          {isDeclared ? 'License declared by package author(s).' : 'License discovered in analysis of package files.'}
        </span>
      </>
    )}
  </div>
);

export default FileViewerOrigin;
